// extracted by mini-css-extract-plugin
export var emailBlockLink = "_pt-0";